import { Layout } from 'antd';
import { cx } from 'common/utils/cx';
import Container from '../Container';
import { BasicProps } from 'antd/lib/layout/layout';

interface Props extends BasicProps {
  type?: 'default' | 'tall';
}

export default function EnhancedHeader({ children, type }: Props) {
  return (
    <Layout.Header className={cx({ 'ant-layout-header-tall': type === 'tall' })}>
      <Container>{children}</Container>
    </Layout.Header>
  );
}
